import React from "react";
import "./index.css";
import { siteContent } from "../content";

const Send = () => {

  return (
    <div className="fullH send">
      <div className="container-lg">
        <div className="colorBox flex flexRow">
          <div className="textCol flex flexCol justifyCenter">
            <h1 className="relative">
              {siteContent.send.title}
              <br />
              <span>{siteContent.send.subtitle}</span>
            </h1>
            <h3 className="relative">
              {siteContent.send.description}
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Send;
